import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { decodeBase64ToImage } from '../../utils/helper';
import styles from './search-staff-for-proposal.module.scss';
import { pdcMeetingApi } from '../../services/pdcMeetingApi';
import { isEmpty } from 'lodash';

const SearchStaffForProposal = ({
  placeholder,
  addTalent,
  limit,
  width,
  currentValue,
  keepInputVal,
  isDisabled,
  setProposalList,
  currentItem,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState(currentValue || '');
  const [search, setSearch] = useState({ value: '', page: 1 });
  const [searchList, setSearchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const roleActive = useSelector((state) => state.user.roleActive);
  const typingTimeoutRef = useRef(null);
  const listInnerRef = useRef(null);
  const searchPrev = useRef(null);
  const [totalItem, setTotalItem] = useState(0);

  const handleScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (clientHeight + Math.ceil(scrollTop) + 1 >= scrollHeight) {
        if (searchList.length < totalItem)
          setSearch((prev) => {
            return {
              ...prev,
              page: prev.page + 1,
            };
          });
      }
    }
  };
  function expand() {
    setExpanded(true);
  }

  function close() {
    setExpanded(false);
  }

  const handleOnchange = (e) => {
    const value = e.target.value;
    if (!value && setProposalList && currentItem) {
      setProposalList((prev) => {
        if (!isEmpty(prev)) {
          return prev.map((item) => {
            if (item?.staff_id === currentItem?.staff_id) {
              return {
                ...item,
                proposal_settings: {
                  ...item?.proposal_settings,
                  staffInfo: {
                    ...item?.proposal_settings?.staffInfo,
                    replacement: {
                      ...item?.proposal_settings?.staffInfo?.replacement,
                      text: '',
                      staff_id: null,
                      replacement: null,
                    },
                  },
                },
              };
            } else {
              return item;
            }
          });
        }
      });
    }
    setSearchTerm(value);
    setLoading(true);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(() => {
      setSearch({
        value: value,
        page: 1,
      });
    }, 500);
    value ? expand() : close();
  };

  const handleOnClick = (item) => {
    addTalent(item);
    if (keepInputVal) {
      setSearchTerm(`${item?.birthName || item?.positionName || 'None'} `);
      // setSearchTerm(
      //   `${item?.birthName || item?.positionName || 'None'} ${`(${handleShowCTForProposal(item?.top_talent_status || item?.ct)}, ${
      //     item?.job_grade || ''
      //   }, ${item?.age || ''})`}`
      // );
    } else {
      setSearchTerm('');
    }
    setSearch('');
    close();
  };

  useEffect(() => {
    async function fetchAPI() {
      setLoading(true);

      try {
        const permission = {
          role: roleActive.roleId,
        };
        const body = { search: search.value, limit: limit || 4, page: search.page };
        const response = await pdcMeetingApi.getSearchStaff(body, permission);
        const data = response?.data?.result;
        if (response.status === 200 && data && data.profiles?.length > 0) {
          if (searchPrev.current === search.value) {
            setSearchList((prev) => {
              return [...prev, ...data.profiles];
            });
          } else {
            setSearchList(data.profiles);
          }

          searchPrev.current = search.value;
          setLoading(false);
          setTotalItem(data.totalProfiles);
        } else {
          setSearchList([]);
          setLoading(false);
        }
      } catch (error) {
        setSearchList([]);
        setLoading(false);
      }
    }
    search.value ? fetchAPI() : setSearchList([]);
  }, [search, roleActive.roleId, limit]);

  return (
    <div
      className={styles.search_box}
      tabIndex={0}
      onBlur={close}
      onFocus={searchTerm ? expand : close}
      style={{ width: width ? `${width}px` : '100%' }}
    >
      <input
        type="search"
        id="search"
        data-testid="search-input"
        name="search"
        aria-label="cost-input"
        placeholder={placeholder}
        className={styles.search_talent}
        onChange={(e) => handleOnchange(e)}
        value={searchTerm}
        autoComplete="off"
        disabled={isDisabled}
      />
      {/* <img className={styles.search_box_icon} src={dropdown_icon} alt="" onClick={() => expand()} /> */}

      {expanded && (
        <SearchListComponent
          data={searchList}
          handleOnClick={handleOnClick}
          loading={loading}
          handleScroll={handleScroll}
          listInnerRef={listInnerRef}
          width={width}
        />
      )}
    </div>
  );
};

const Loading = ({ width }) => {
  return (
    <div className={styles.search_list} style={{ width: width ? `${width}px` : '100%' }}>
      <div className={styles.dot_flasing}></div>
    </div>
  );
};

function SearchListComponent(props) {
  const { data, handleOnClick, loading, handleScroll, listInnerRef, width } = props;

  if (loading === true) {
    return <Loading width={width} />;
  }

  if (data && data.length > 0) {
    const listItems = data.map((item, index) => {
      return (
        <li
          className={styles.search_item}
          key={`${item.staffId}-${index}`}
          onMouseDown={() => handleOnClick(item)}
          data-testid="list-click"
        >
          <div className={styles.avatar}>
            <img src={decodeBase64ToImage(item?.image)} alt="avatar" />
          </div>
          <div className={styles.invidual}>
            <div data-testid="name" className={styles.name}>
              {item.birthName} ({item.staffId})
            </div>
            <div data-testid="opu" className={styles.name1}>
              {item.opu}
            </div>
            <div data-testid="sg" className={styles.name1}>
              {item.sg}
            </div>
          </div>
        </li>
      );
    });
    return (
      <ul
        className={styles.search_list}
        data-testid="data-is-true"
        onScroll={handleScroll}
        ref={listInnerRef}
        style={{ width: width ? `${width}px` : '100%' }}
      >
        {listItems}
      </ul>
    );
  } else {
    return (
      <div className={styles.search_list} style={{ width: width ? `${width}px` : '100%' }}>
        Search not found ...
      </div>
    );
  }
}

export default SearchStaffForProposal;
